<template>
  <div>
    <el-button
      style="position: absolute;"
      plain
      type="single-number"
      @click="dialogVisible = true"
    >
      选择人员
    </el-button>
    <el-advanced-user-selector
      :dialogVisible.sync="dialogVisible"
      :agentId="agentId"
      :baseAppId="baseAppId"
      :mode="mode"
      @selectedUserSuccess="selectedUserSuccess"
    >
    </el-advanced-user-selector>
  </div>
</template>

<script>
import { getArgs } from "@/basa/utils";
export default {
  props: {
    mode: {
      validator: value => {
        return ["checkbox", "radio"].includes(value);
      },
      default: "checkbox"
    }
  },
  data() {
    return {
      dialogVisible: false,
      agentId: getArgs("a"),
      baseAppId: Number(this.$store.state.user.userDetal.appId)
    };
  },
  methods: {
    selectedUserSuccess(obj) {
      alert(JSON.stringify(obj));
      this.$emit("inventoryConfirm", obj);
    }
  }
};
</script>
